module.exports = __webpack_public_path__ + "img/sjtj.fd774799.png";